export default "__VITE_ASSET__DwqeyHBv__"